<template>
    <AdminLayout>
        <section class="grid grid-cols-7">
            <div class="col-span-5 py-2 px-10">
                <div class="mt-8">
                    <div class="">
                        <div class="flex justify-between">
                            <p class="font-semibold text-2xl text-neutral-800">Edit Employee</p>
                        </div>
                        <div v-if="dataLoaded" class="overflow-x-auto sm:rounded-lg">
                            <form v-on:submit.prevent="submitForm" ref="form" name="form">
                               
                                <div class="grid grid-cols-2 gap-6 pt-6" v-for="(data, index) in formList" :key="index">
                                    <!-- <p>{{ data }}</p> -->
                                    <div class="" v-for="(item, index) in data.items" :key="index">
                                        <!-- <p>{{ item }}</p> -->
                                        <div class="" v-if="item.name == 'First Name' && item.status == true">
                                            <label class="input-label">First Name:</label>
                                            <input class="form-control" type="text" :class="{ filderror: v3$.fname.$error }" v-model="state3.fname" placeholder="First Name" @input="state3.fname = state3.fname.replace(/[^a-zA-Z\s]/g, '')">
                                            <span class="error-span" v-if="v3$.fname.$error">Please Enter First Name</span>
                                        </div>

                                        <div class="" v-if="item.name == 'Last Name' && item.status == true">
                                            <label class="input-label">Last Name:</label>
                                            <input class="form-control" type="text" :class="{ filderror: v3$.lname.$error }" v-model="state3.lname" placeholder="Last Name" @input="state3.fname = state3.fname.replace(/[^a-zA-Z\s]/g, '')">
                                            <span class="error-span" v-if="v3$.lname.$error">Please Enter Last Name</span>
                                        </div>

                                        <div class="" v-if="item.name == 'Gender' && item.status == true">
                                            <label class="input-label">Gender:</label>
                                            <select class="form-control-select" v-model="state3.gender">
                                                <option value="undefined" disabled>-Select One-</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </div>

                                        <div class="" v-if="item.name == 'Date of Birth' && item.status == true">
                                            <label class="input-label">Date of Birth:</label>
                                            <datepicker class="form-control" :class="{ filderror: v3$.dob.$error }" v-model="state3.dob" :disabledDates="(date) => date <= new Date()" placeholder="DOB"/>
                                            <span class="error-span" v-if="v3$.dob.$error">Please Enter Date of Birth</span>
                                        </div>

                                        <div class="" v-if="item.name == 'Nationality' && item.status == true">
                                            <label class="input-label">Country:</label>
                                            
                                            <select class="form-control-select" v-model="state3.country" >
                                                <option class="text-neutral-400" disabled>Select Country</option>
                                                <option :value="country.code" v-for="country in countryList" :key="country.id" >{{ country.name }}</option>
                                            </select>
                                        </div>

                                        <div class="" v-if="item.name == 'Marital Status' && item.status == true">
                                            <label class="input-label">Marital Status:</label>
                                            <select class="form-control-select" v-model="state3.married">
                                                <option value="undefined" disabled>-Select One-</option>
                                                <option value="Married">Married</option>
                                                <option value="Single">Single</option>
                                                <option value="Divorcee">Divorced</option>
                                                <option value="Widowed">Widowed</option>
                                            </select>
                                        </div>

                                        <div class="" v-if="item.name == 'Email' && item.status == true">
                                            <label class="input-label">Email:</label>
                                            <input class="form-control" type="text" :class="{ filderror: v3$.email.$error }" v-model="state3.email" placeholder="Enter email">
                                            <span class="error-span" v-if="v3$.email.$error">Please Enter Email</span>
                                        </div>

                                        <div class="" v-if="item.name == 'Phone' && item.status == true">
                                            <label class="input-label">Phone:</label>
                                            <input class="form-control" type="text" :class="{ filderror: v3$.phone.$error }" v-model="state3.phone" placeholder="Phone" @input="state3.phone = state3.phone.replace(/[^0-9]/g, '')" maxlength="10">
                                            <span class="error-span" v-if="v3$.phone.$error">Please Enter Phone</span>
                                        </div>
                                        
                                        <div class="" v-if="item.name == 'Employee ID' && item.status == true">
                                            <label class="input-label">Employee Id:</label>
                                            <input class="form-control" type="text" :class="{ filderror: v3$.empid.$error }" v-model="state3.empid" placeholder="EMP ID">
                                            <span class="error-span" v-if="v3$.empid.$error">Please Enter EMP ID</span>
                                        </div>

                                        <div class="" v-if="item.name == 'Job Title/Position' && item.status == true">
                                            <label class="input-label">Job Title:</label>
                                            <input class="form-control" type="text" :class="{ filderror: v3$.jobtitle.$error }" v-model="state3.jobtitle" placeholder="Job Title">
                                            <span class="error-span" v-if="v3$.jobtitle.$error">Please Enter Job Title</span>
                                        </div>

                                        <div class="" v-if="item.name == 'Date of Joining' && item.status == true">
                                            <label class="input-label">Date of Joining:</label>
                                            <input class="form-control"  :class="{ filderror: v3$.doj.$error }" v-model="state3.doj" placeholder="DOJ" readonly/>
                                            <span class="error-span" v-if="v3$.doj.$error">Please Enter Date of Joining</span>
                                        </div>

                                        <div class="col-span-2" v-if="item.name == 'Department/Division' && item.status == true">
                                            <div class="grid grid-cols-2 gap-5">
                                                <div class="">
                                                    <label class="input-label">Department:</label>
                                                    <input class="form-control" type="text" :class="{ filderror: v3$.dept.$error }" v-model="state3.dept" placeholder="Department" readonly>
                                                    <!-- <select class="form-control-select" :class="{ filderror: v3$.dept.$error }" v-model="state3.dept"  v-on:change="getDesignationByDepartmentIdWiseList(state3.dept)">
                                                        <option disabled value="">Select</option>
                                                        <option v-for="department in departmentList" :key="department.id" :value="department.id">{{ department.name }}</option>
                                                    </select> -->
                                                    <span class="error-span" v-if="v3$.dept.$error">Please Enter Department</span>
                                                </div>

                                                <div class="">
                                                    <label class="input-label">Designation:</label>
                                                    <input class="form-control" type="text" :class="{ filderror: v3$.dept.$error }" v-model="state3.designation" placeholder="Designation" readonly>
                                                    <!-- <select class="form-control-select" :class="{ filderror: v3$.dept.$error }" v-model="state3.designation">
                                                        <option value="">Select</option>
                                                        <option v-for="desidnation in designationList" :key="desidnation.id" :value="desidnation.id">{{ desidnation.name }}</option>                                                       
                                                    </select> -->
                                                    <span class="error-span" v-if="v3$.dept.$error">Please Enter Designation</span>
                                                </div>
                                            </div>
                                        </div>

                                        

                                        <div class="" v-if="item.name == 'Supervisor/Manager Name' && item.status == true">
                                            <label class="input-label">Reporting Manager:</label>
                                            <select v-model="state3.reporting_manager" class="form-control-select">
                                                <option value="" disabled>-Select One-</option>
                                                <option v-for="rManager in reportingManagerList" :key="rManager.id" :value="rManager.id">{{ rManager.name }}</option>
                                            </select>
                                        </div>

                                       

                                        <!-- <div class="addNewFirst adnleft" v-if="item.name == 'Supervisor/Manager Name' && item.status == true">
                                            <label>Allocate Roster:</label>
                                            <select v-model="state3.allocated_roster">
                                                <option value="" disabled>-Select One-</option>
                                                <option v-for="rManager in reportingManagerList" :key="rManager.id" :value="rManager.id">{{ rManager.name }}</option>
                                            </select>
                                        </div> -->
                                    
                                        <div class="" v-if="item.name == 'Salary/Wage' && item.status == true">
                                            <label class="input-label">Gross Salary:</label>
                                            <input class="form-control" type="number" v-model="state3.gross_salary" placeholder="Gross Salary" readonly>
                                        </div>

                                        <div class="" v-if="item.name == 'Bank Account Number' && item.status == true">
                                            <label class="input-label">Bank Account Number:</label>
                                            <input class="form-control" type="text" :class="{ filderror: v3$.acc_number.$error }" v-model="state3.acc_number" placeholder="Bank A/C Number">
                                            <span class="error-span" v-if="v3$.acc_number.$error">Please Enter Bank A/C Number</span>
                                        </div>

                                        <div class="" v-if="item.name == 'Pan Number' && item.status == true">
                                            <label class="input-label">PAN Number:</label>
                                            <input class="form-control" type="text" :class="{ filderror: v3$.pan.$error }" v-model="state3.pan" placeholder="PAN Number">
                                            <span class="error-span" v-if="v3$.pan.$error">Please Enter Department</span>
                                        </div>

                                        <div class="" v-if="item.name == 'Benifit Related Documents' && item.status == true">
                                            <label class="input-label">Upload Benifit Related Documents(If Any):</label>
                                            <!-- <input type="file" ref="benifitRelatedImage" name="benifitRelatedImage" class="addNewInput" @change="updateBenifitDoc"> -->
                                            <label class="form-control-file relative" html-for="benifitRelatedImage">
                                                <input type="file" ref="benifitRelatedImage" id="benifitRelatedImage" name="benifitRelatedImage" class="hidden" @change="updateBenifitDoc">
                                                <span class="block truncate text-ellipsis text-neutral-800" v-if="this.state3.benifitRelatedImage?.name">
                                                    {{ this.state3.benifitRelatedImage?.name }}
                                                </span>
                                                <span v-else class="text-sm">No file chosen</span>
                                                <span class="absolute right-3  top-2.5">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" data-slot="icon" class="w-5 h-5">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
                                                    </svg>
                                                </span>
                                            </label>
                                        </div>
                                    
                                        <div class="" v-if="item.name == 'Highest Education Level' && item.status == true">
                                            <label class="input-label">Highest Education Level:</label>
                                            <select v-model="state3.edu_level" class="form-control-select" :class="{ filderror: v3$.edu_level.$error }" >
                                                <option value="undefined" disabled>-Select One-</option>

                                                <option v-for="education in educationList" :key="education.id" :value="education.id">{{ education.name }}</option>

                                            </select>
                                            <span class="error-span" v-if="v3$.edu_level.$error">Select Highest Education</span>
                                        </div>

                                        <div class="" v-if="item.name == 'School/Institution Name' && item.status == true">
                                            <label class="input-label">School/Institution Name:</label>
                                            <input class="form-control" type="text" :class="{ filderror: v3$.institution_name.$error }" v-model="state3.institution_name" placeholder="School/Institution Name">
                                            <span class="error-span" v-if="v3$.institution_name.$error">Add School/Institution Name</span>
                                        </div>

                                        <div class="" v-if="item.name == 'Degree/Certificate Obtained' && item.status == true">
                                            <label class="input-label">Upload Highest Educational Certificate:</label>
                                            <!-- <input type="file" ref="degreeObtainedImage" name="degreeObtainedImage" class="addNewInput" @change="updateEducationalDoc"> -->

                                            <label class="form-control-file relative" html-for="degreeObtainedImage">
                                                <input type="file" ref="degreeObtainedImage" id="degreeObtainedImage" name="degreeObtainedImage" class="hidden" @change="updateEducationalDoc">
                                                <span class="block truncate text-ellipsis text-neutral-800" v-if="this.state3.degreeObtainedImage?.name">
                                                    {{ this.state3.degreeObtainedImage?.name }}
                                                </span>
                                                <span v-else class="text-sm">No file chosen</span>
                                                <span class="absolute right-3  top-2.5">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" data-slot="icon" class="w-5 h-5">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
                                                    </svg>
                                                </span>
                                            </label>

                                        </div>
                                    
                                        <div class="" v-if="item.name == 'Previous Employers' && item.status == true">
                                            <label class="input-label">Previous Employer:</label>
                                            <input class="form-control" type="text" v-model="state3.prev_emp" placeholder="Previous Employer">
                                            <!-- :class="{ filderror: v3$.prev_emp.$error }" <span class="error-span" v-if="v3$.prev_emp.$error">Previous Employer</span> -->
                                        </div>

                                        <div class="" v-if="item.name == 'Relevant Skills' && item.status == true">
                                            <label class="input-label">Relevent skills:</label>
                                            <input
                                            class="form-control"
                                            v-model="newTag"
                                            @keydown.enter.prevent="addTag"
                                            @blur="addTag"
                                            :placeholder="selectedTags.length ? '' : 'Type or select a tag'"
                                            ref="tagInput"
                                            />
                                            <div class="selected-tags">
                                                <span
                                                v-for="(tag, index) in selectedTags"
                                                :key="index"
                                                class="tag"
                                                >
                                                {{ tag }}
                                                <button @click="removeTag(index)">x</button>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="" v-if="item.name == 'Upload Certificates' && item.status == true">
                                            <label class="input-label">Upload Certificates:</label>
                                            <!-- <input type="file" ref="certificateImage" name="certificateImage" class="addNewInput" @change="updateJobExperience"> -->
                                            <label class="form-control-file relative" html-for="certificateImage">
                                                <input type="file" ref="certificateImage" id="certificateImage" name="certificateImage" class="hidden" @change="updateJobExperience">
                                                <span class="block truncate text-ellipsis text-neutral-800" v-if="this.state3.certificateImage?.name">
                                                    {{ this.state3.certificateImage?.name }}
                                                </span>
                                                <span v-else class="text-sm">No file chosen</span>
                                                <span class="absolute right-3  top-2.5">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" data-slot="icon" class="w-5 h-5">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
                                                    </svg>
                                                </span>
                                            </label>
                                        </div>

                                        <div class="" v-if="item.name == 'Relevant Work Experience' && item.status == true">
                                            <label class="input-label">Job Experience (In Years):</label>
                                            <input class="form-control" type="number" v-model="state3.job_exp_years" placeholder="Job Experience" min="0" max="50">
                                            <!-- :class="{ filderror: v3$.job_exp_years.$error }"  <span class="error-span" v-if="v3$.job_exp_years.$error">Job Experience</span> -->
                                        </div>

                                        <div class="" v-if="item.name == 'Resume/CV' && item.status == true">
                                            <label class="input-label">Upload CV:</label>
                                            
                                            <label class="form-control-file relative" html-for="CVImage">
                                                <input type="file" ref="CVImage" id="CVImage" name="CVImage" class="hidden" @change="updateCV">
                                                <span class="block truncate text-ellipsis text-neutral-800" v-if="this.state3.CVImage?.name">
                                                    {{ this.state3.CVImage?.name }}
                                                </span>
                                                <span v-else class="text-sm">No file chosen</span>
                                                <span class="absolute right-3  top-2.5">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" data-slot="icon" class="w-5 h-5">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
                                                    </svg>
                                                </span>
                                            </label>
                                        </div>

                                        <div class="" v-if="item.name == 'Identification Documents' && item.status == true">
                                            <label class="input-label">Upload ID Proof:</label>

                                            <label class="form-control-file relative" html-for="IDProofImage">
                                                <input type="file" ref="IDProofImage" id="IDProofImage" name="IDProofImage" class="hidden" @change="updateID">
                                                <span class="block truncate text-ellipsis text-neutral-800" v-if="this.state3.IDProofImage?.name">
                                                    {{ this.state3.IDProofImage?.name }}
                                                </span>
                                                <span v-else class="text-sm">No file chosen</span>
                                                <span class="absolute right-3  top-2.5">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" data-slot="icon" class="w-5 h-5">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
                                                    </svg>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="">
                                    <label class="input-label">Upload Profile Image:</label>

                                    <label class="form-control-file relative" html-for="IDProofImage">
                                        <input type="file" ref="IDProofImage" id="IDProofImage" name="IDProofImage" class="hidden" @change="updateProfile">
                                        <span class="block truncate text-ellipsis text-neutral-800" v-if="this.state3.profileImage?.name">
                                            {{ this.state3.profileImage?.name }}
                                        </span>
                                        <span v-else class="text-sm">No file chosen</span>
                                        <span class="absolute right-3  top-2.5">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" data-slot="icon" class="w-5 h-5">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
                                            </svg>
                                        </span>
                                    </label>
                                </div>
                                <div class="col-span-2" >
                                    <div class="grid grid-cols-2 gap-5">
                                        <div class="">
                                            <label class="input-label">UAN No:</label>
                                            <input class="form-control" type="text" v-model="state3.uan" placeholder="UAN Number" >
                                        </div>

                                        <div class="">
                                            <label class="input-label">ESIC No:</label>
                                            <input class="form-control" type="text"  v-model="state3.esic" placeholder="ESIC Number">                                           
                                        </div>
                                    </div>
                                </div>
                                <div class="">
                                    <label class="input-label">Add Role:</label>
                                    <select class="form-control-select" v-model="state3.role" :class="{ filderror: v3$.role.$error }" >
                                        <option value="">Select Role</option>
                                        <option v-for="role in roleList" :key="role.id" :value="role.id">{{ role.name }}</option>
                                    </select>
                                    <span class="error-span" v-if="v3$.role.$error">Please Enter Role</span>
                                </div>

                                
                                <div class="main-error-msg" v-if="errormessage || successmessage" :class="errormessage ? '' : 'suce-area'">
                                    <h5 :class="{show:errormessage}" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-x-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                    </svg> {{errormessage}}</h5> 
                                    <h5 :class="{show:successmessage}" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" class="bi bi-check-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                                    </svg> {{successmessage}}</h5> 
                                </div>

                             
                                <div class="flex justify-between py-10">
                                    <button type="button" class="mr-2 btn-gray-light" >Back</button>
                                    <button type="submit" class="ml-auto btn-primary" :disabled="buttonclick" :class="buttonclick == true ? 'opacity-50 cursor-not-allowed' : ''">
                                        <span class="px-2">Save</span>
                                        <span>
                                            <span v-if="this.btnLoader" class="animate-spin h-4 w-4 inline-block border-2 border-white border-r-white/10 border-t-white/10 rounded-full"></span>
                                        </span>
                                    </button>
                                </div>
                             
                            </form>
                        </div>

                        <div v-else class="grid grid-cols-2 gap-6 pt-6">
                            <div class="animate-pulse" v-for="index in 20" :key="index">
                                <div class="w-28 rounded h-5 bg-neutral-200/80"></div>
                                <div class="w-full rounded h-10 bg-neutral-200 mt-2"></div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                
            </div>
            <RightSideBar/>
        </section>
    </AdminLayout>
</template>
<script>
    import RightSideBar from '../../components/RightSideBar.vue';
    import AdminLayout from './AdminLayout.vue';
    // import AdminSettingModal from '../../components/AdminSettingModal.vue';
    // import moment from 'moment';
    // import DropDown from '../../components/DropDown.vue';
    // import DatePickerDate from '../../components/DatePickerDate.vue';
    // import { ChevronRightIcon} from '@heroicons/vue/24/solid';
    // import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue';
    import { reactive, computed } from "vue";
    import useValidate from "@vuelidate/core";
    import { required, email, minLength, maxLength } from "@vuelidate/validators";
    // import { reactive } from "vue";
    import { BASE_URL } from "../../config";
    import axios from "axios";
    import { createLocal } from 'the-storages';
    import Datepicker from 'vue3-datepicker';
    import { createToast } from 'mosha-vue-toastify';

    const mirror = createLocal();
    const storage = mirror._prx;

    export default {
        name: 'Add-new-employee',
        components:{
            AdminLayout,
            Datepicker,
            RightSideBar,
        },
        setup() {
            const state3 = reactive({
                fname: '',
                lname:'',
                email: '',
                phone: '',
                doj: '',
                dob: '',
                designation:'',
                casual:'',
                sick:'',
                blood:'',
                address:'',
                message:'',
                empid:'',
                jobtitle:'',
                dept:'',
                gross_salary:'',
                acc_number:'',
                pan:'',
                institution_name:'',
                prev_emp:'',
                job_exp_years:'',   
                uan:'',
                esic:'',            
                role: ''
            })
            const rules3 = computed(() => {
                return {
                    fname: { required },
                    lname: { required },
                    email: { required,email },
                    phone: { required, minLength: minLength(10), maxLength: maxLength(12) },
                    //   message: { required },
                    doj:{ required },
                    dob:{ required },
                    empid:{ required },
                    //   designation:{ required },
                    edu_level:{ required },
                    jobtitle:{ required },
                    dept:{ required },
                    acc_number:{ required },
                    pan:{ required },
                    institution_name:{ required },
                    // prev_emp:{ required },
                    // job_exp_years:{ required },
                    role:{required}
                    //   casual:{ required },
                    //   sick:{ required }
                }
            })
            const v3$ = useValidate(rules3, state3)
            return {
                state3,
                v3$
            }
        },
        data() {
            return {
                btnLoader: false,
                form: {
                    fname: '',
                    lname:'',
                    email: '',
                    phone: '',
                    message:'',
                    doj:'',
                    dob:'',
                    designation:'',
                    casual:'',
                    sick:'',
                    photo: {}
                },
                errormessage: '',
                successmessage: '',
                errormessage1: '',
                successmessage1: '',
                files: "",
                type:"",
                //   state3: {},
                buttonclick:false,
                previewFile: null,
                previewUrl: null,
                dept: undefined,
                formList:[],
                storage: storage,
                benifitdoc:'',
                edudoc:'',
                selectedTags: [], 
                newTag: '', 
                availableTags: ['Tag 1', 'Tag 2', 'Tag 3', 'Tag 4'],
                jobexpdoc:'',
                iddoc:'',
                cvdoc:'',
                countryList:[],                
                reportingManagerList:[],
                roleList:[],
                educationList:[],
                dataLoaded: false,
            }
        },
        computed:{ 
        },
        async created(){
            this.getCountryList();
            this.getReportingManagerList();
            this.getEducationManagerList();
            this.getRoleList();
            await axios.post(BASE_URL + '/fetchemployeemasterdetails',{'company_id':this.storage.company_id})
            .then((response)=> {
                console.log(response.data);
                if (response.data.formdetails != false) {
                    this.formList = response.data.formdetails;
                    this.dataLoaded = true;
                }
                console.log(this.formList);
            })


            this.url_data = this.$route.params.slug;
            console.log("Employee ID:", this.url_data);

            try {
                const response = await axios.post(BASE_URL + '/fetch-emp-details', { empid: this.url_data });
                console.log("Employee Details Response:", response.data);

                if (response.data.formdetails !== false) {
                    const empdata = response.data.empDetails;
                    console.log("Employee Data:", empdata);

                    // Populate state3 with fetched data
                    this.state3.fname = empdata.fname;
                    this.state3.lname = empdata.lname;
                    this.state3.gender = empdata.gender;
                    this.state3.dob = new Date(empdata.dob);
                    this.state3.country = empdata.country;
                    this.state3.married = empdata.married;
                    this.state3.email = empdata.email;
                    this.state3.phone = empdata.phone;
                    this.state3.empid = empdata.empid;
                    this.state3.jobtitle = empdata.jobtitle;
                    this.state3.doj = empdata.doj;
                    this.state3.dept = empdata.dept;
                    this.state3.designation = empdata.designation;
                    this.state3.reporting_manager = empdata.reporting_manager;
                    this.state3.gross_salary = empdata.gross_salary;
                    this.state3.acc_number = empdata.acc_number;
                    this.state3.pan = empdata.pan;
                    this.state3.edu_level = empdata.edu_level;
                    this.state3.institution_name = empdata.edu_institue;
                    this.state3.prev_emp = empdata.prev_employer;
                    this.state3.job_exp_years = empdata.jobexperience;
                    this.state3.uan = empdata.uan;
                    this.state3.esic = empdata.esic;
                    this.state3.role = response.data.userDetails.role_id;
                    // Populate selected tags
                    this.selectedTags = empdata.emp_skills.split(',');
                }
            } catch (error) {
                console.error("Error fetching employee details:", error);
            }


        },
        methods:{
            async getEducationManagerList() {
                const formData = {
                    "company_id":this.storage.companyDetails.id
                };
                await axios.post(BASE_URL + '/get-emp-education-list',formData)
                .then((response)=>{
                    this.educationList =  response.data.educationList;
                    console.log("EDUCATION LIST:: ", response.data.educationLevelList);
                })
            },
            async getRoleList() {
                const formData = {
                    "company_id":this.storage.companyDetails.id
                };
                await axios.post(BASE_URL + '/get-roles',formData)
                .then((response)=>{
                    this.roleList =  response.data.roleList;
                    console.log("Role LIST:: ",response.data);
                })
            },
            async getReportingManagerList() {
                const formData = {
                    "company_id":this.storage.companyDetails.id
                };
                await axios.post(BASE_URL + '/get-emp-reporting-manager-list',formData)
                .then((response)=>{
                    this.reportingManagerList =  response.data.reportingManagerList;
                    console.log("REPORTING MANAGER LIST:: ",response.data);
                })
            },
           
           
            async getCountryList(){
                await axios.get(BASE_URL + '/country-list')
                .then((response)=>{
                    this.countryList =  response.data.countryList;
                    console.log("COUNTRY LIST:: ",response.data);
                })
            },
            updateBenifitDoc(e){
                const file = e.target.files[0];
                this.state3.benifitRelatedImage = file;
                this.benifitRelatedImagePath = URL.createObjectURL(file);
                console.log("Benifit Related Image: ", this.state3.benifitRelatedImage);
            },

            updateEducationalDoc(e){
                const file = e.target.files[0];
                this.state3.degreeObtainedImage = file;
                this.degreeObtainedImagePath = URL.createObjectURL(file);
                console.log("Degree Obtained Image: ", this.state3.degreeObtainedImage);
            },

            updateJobExperience(e){
                const file = e.target.files[0];
                this.state3.certificateImage = file;
                this.certificateImagePath = URL.createObjectURL(file);
                console.log("Certificate Image: ", this.state3.certificateImage);
            },

            updateCV(e){
                const file = e.target.files[0];
                this.state3.CVImage = file;
                this.CVImagePath = URL.createObjectURL(file);
                console.log("CV Image: ", this.state3.CVImage);
            },

            updateID(e){
                const file = e.target.files[0];
                this.state3.IDProofImage = file;
                this.IDProofImagePath = URL.createObjectURL(file);
                console.log("ID Proof Image: ", this.state3.IDProofImage);
            },

            updateProfile(e){
                const file = e.target.files[0];
                this.state3.profileImage = file;
                this.profileImagePath = URL.createObjectURL(file);
                console.log("ID Proof Image: ", this.state3.profileImage);
            },

            addTag() {
                if (this.newTag.trim() !== '') {
                    // Check if the entered tag is already in the list of available tags
                    const tagExists = this.availableTags.includes(this.newTag);

                    // If the tag doesn't exist, add it to the list of selected tags
                    if (!tagExists) {
                    this.selectedTags.push(this.newTag);
                    console.log("jfyugfyug",this.selectedTags);
                    }

                    // Clear the input field
                    this.newTag = '';

                    // Focus on the input field again
                    // this.$refs.tagInput.focus();
                }
            },

            removeTag(index) {
             this.selectedTags.splice(index, 1);
            },

            async submitForm(){
                // this.buttonclick = true;
                this.btnLoader = true;
                this.v3$.$validate()
                console.log("uuidgdygd", this.storage.company_id);
                if (!this.v3$.$error) {
                    this.buttonclick = true;
                    
                    console.log("ldhuigduy",this.state3.doj);
                    if (this.state3.dob != '') {
                        var dob_month = this.state3.dob.getMonth()+1;
                        var dob_year = this.state3.dob.getFullYear();
                        var dob_date = this.state3.dob.getDate();
                        var dob_month_string = dob_month.toLocaleString().padStart(2, '0');
                        // var dob_year_string = dob_year.toLocaleString();
                        var dob_date_string = dob_date.toLocaleString().padStart(2, '0');
            
                        console.log("dob_year",dob_year);
                        // console.log("dob-date2",dob_year_string );
                        console.log("dob_month_string",dob_month_string);
                        console.log("dob_date_string",dob_date_string);
                        var formatted_dob = (dob_year.toString()).concat("-",dob_month_string).concat("-",dob_date_string);
                        console.log("formatted_dob",formatted_dob);
                    } else {
                        formatted_dob = null;
                    }

                   
                    let formData = new FormData();
                    formData.append('company_id',this.storage.company_id);
                    formData.append('ipAddress',this.storage.ipAddress);
                    formData.append('fname', this.state3.fname);
                    formData.append('lname', this.state3.lname);
                    formData.append('gender', this.state3.gender);
                    formData.append('dob', formatted_dob);
                    formData.append('dob_datepicker', this.state3.dob);
                    formData.append('country', this.state3.country);
                    formData.append('married', this.state3.married);
                    formData.append('empid', this.state3.empid);
                    formData.append('doj', this.state3.doj);
                    formData.append('doj_datepicker', this.state3.doj);
                    formData.append('jobtitle', this.state3.jobtitle);
                    formData.append('dept', this.state3.dept);
                    formData.append('reporting_manager', this.state3.reporting_manager);
                    formData.append('gross_salary', this.state3.gross_salary);
                    formData.append('acc_number', this.state3.acc_number);
                    formData.append('pan', this.state3.pan);
                    formData.append('benifitdoc', this.state3.benifitRelatedImage);
                    formData.append('edu_level', this.state3.edu_level);
                    formData.append('edu_institue', this.state3.institution_name);
                    formData.append('edu_certificate', this.state3.degreeObtainedImage);
                    formData.append('prev_employer', this.state3.prev_emp);
                    formData.append('emp_skills', this.selectedTags);
                    formData.append('experience_certificate', this.state3.certificateImage);
                    formData.append('jobexperience', this.state3.job_exp_years);
                    formData.append('emp_cv', this.state3.CVImage);
                    formData.append('emp_id_doc', this.state3.IDProofImage);
                    formData.append('email', this.state3.email);
                    formData.append('phone', this.state3.phone);
                    formData.append('designation', this.state3.designation);                    
                    formData.append('profile_image', this.state3.profileImage);
                    formData.append('uan', this.state3.uan);
                    formData.append('esic', this.state3.esic);
                    formData.append('role', this.state3.role);

                    console.log("formdata", formData);
                    await axios.post(BASE_URL + '/update-employee-details',formData)
                        .then((response)=>{
                            if (response.data.success== 'success') {
                                this.btnLoader = false;
                                this.buttonclick = false;
                                this.tostMessage(response.data.success, response.data.message);
                                this.$router.push('/employee-list'); 
                            }else {
                                this.btnLoader = false;
                                this.buttonclick = false;
                                this.tostMessage(response.data.success, response.data.message);
                            }

                        })
                } else {
                    this.buttonclick = false;
                    this.btnLoader = false;
                    console.log("bdygfyduf");
                }
            },
            tostMessage(status,message){
                createToast({
                    // title: title,
                    description: message
                },
                {
                type: status,
                timeout: 2500,
                position: 'bottom-right',
                showIcon: 'true'
                })
            },
        }
    }
</script>
<style>
.tag-input {
  display: flex;
  align-items: center;
}
.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.tag {
  background-color: #0074d9;
  color: #ffffff;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.tag button {
  background: none;
  border: none;
  color: #ffffff;
  font-weight: bold;
  margin-left: 4px;
  cursor: pointer;
}
.tag-input input {
  flex-grow: 1;
}

</style>